import { render } from "./OrderReturnExchangeModal.vue?vue&type=template&id=76426f23&ts=true&lang=pug"
import script from "./OrderReturnExchangeModal.vue?vue&type=script&lang=ts"
export * from "./OrderReturnExchangeModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__